import { filtersHelper } from '@/utils';

export const catalogSubcategoryModel = (data = {}) => ({
    uuid: data.uuid || '',
    name: data.name || '',
    description: data.description || '',
    sequence: data.sequence ? null : Number(data.sequence),
    catalogCategoryUUID: data.catalog_category?.uuid || '',
    catalogCategory: data.catalog_category || null,
    catalogCategoryName: data.catalog_category?.name || '',
    iconUrl:  data.icon_path  || '',
    isActive: data.is_active == null ? true : data.is_active === true || Number(data.is_active) === 1,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
});
